import $ from 'jquery'

export default () => {
    const trigger = $('.js-modal-trigger');
    const modal = $('.js-modal');
    const content = $('.js-modal-content');
    const close = $('.js-modal-close');

    trigger.on('click', ({currentTarget}) => {
        const id = $(currentTarget).attr('data-modal-id');

        showModal(id);
    });

    modal.on('click', ({currentTarget}) => {
        $(currentTarget).removeClass('is-active');
    });

    modal.each((index, el) => {
        $(el).appendTo('body');
    });

    content.on('click', (e) => {
        e.stopPropagation();
    });

    close.on('click', ({currentTarget}) => {
        $(currentTarget).parents('.js-modal').removeClass('is-active')
    })
}

export const showModal = (id) => {
    $(`#${id}`).addClass('is-active');
};



// WEBPACK FOOTER //
// ../src/scripts/modules/modal.js